<template>
  <div class="max-w-7xl mx-auto px-6 lg:px-8">
    <PageTitle v-bind:title="title" v-bind:admin="false" />

    <!-- <QuoteTest /> -->

    <TheCoursesMenu v-bind:index="1" />

    <div v-if="true">
      <template v-if="((data.lastAdded) && (data.lastAdded.length > 2))">
        <h2 class="text-lg font-semibold text-gray-900 sm:text-xl my-8">
          Последние добавленные Курсы:
        </h2>
        <CoursesSlider1 v-bind:courses="data.lastAdded" />
      </template>
    </div>

    <!-- <h1>!!!!!{{ this.$route.query.department }}</h1> -->

    <ErrorMessage v-if="errors.load" :error="errors.load" />

    <div class="space-y-6 mt-8 mb-4">
      <div class="bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
        <div class="md:grid md:grid-cols-1 md:gap-6">
          <div class="mt-5 md:mt-0">
            <form action="courses" method="GET">
              <div class="grid grid-cols-1 lg:flex gap-4">
                <div class="flex-grow">
                  <label for="department" class="sr-only"> Кафедра </label>
                  <div class="mt-1">
                    <select
                      v-model="department_id"
                      id="department"
                      name="department"
                      autocomplete="department"
                      class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                    >
                      <option
                        value="-1"
                        :selected="
                          this.$route.query.department == -1 ||
                          !this.$route.query.department
                        "
                      >
                        Все Кафедры
                      </option>
                      <option
                        v-for="item in data.departments"
                        :key="item.id"
                        :value="item.id"
                        :selected="$route.query.department == item.id"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="flex-grow">
                  <label for="name" class="sr-only">Название</label>
                  <input
                    v-model="name"
                    class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                    name="name"
                    type="text"
                    id="name"
                  />
                </div>
                <div class="flex-shrink">
                  <button
                    type="submit"
                    class="mt-1 ml-auto inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  >
                    Search
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="relative py-16 sm:py-24 lg:py-32">
      <div class="relative">
        <div
          class="text-center mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl"
        >
          <!--
          <h2
            class="text-base font-semibold tracking-wider text-cyan-600 uppercase"
          >
            Learn
          </h2>
          -->
          <p
            class="mt-2 text-3xl font-extrabold text-gray-900 tracking-tight sm:text-4xl"
          >
            Все курсы
          </p>
          <p class="mt-5 mx-auto max-w-prose text-xl text-gray-500">
            Изучайте материалы курсов, смотрите видео лекции онлайн, сдавайте тесты и совершенствуйте свои знания!
          </p>
        </div>
        <Loader v-if="loading" class="mt-4" />

        <div
          v-else
          class="mt-12 mx-auto max-w-md px-4 grid gap-8 sm:max-w-lg sm:px-6 lg:px-8 lg:grid-cols-3 lg:max-w-7xl"
        >
          <CourseCard
            v-for="course in data.courses"
            v-bind:key="course.id"
            v-bind:course="course"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Loader from "@/components/Loader";
import ErrorMessage from "@/components/ErrorMessage";

import CoursesSlider1 from "@/components/CoursesSlider1";
import PageTitle from "@/components/PageTitle";
import TheCoursesMenu from "@/components/TheCoursesMenu";
import CourseCard from "@/components/CourseCard";
// import QuoteTest from "@/components/QuoteTest";

export default {
  components: {
    Loader,
    ErrorMessage,
    CoursesSlider1,
    PageTitle,
    TheCoursesMenu,
    CourseCard,
    // QuoteTest,
  },
  data() {
    return {
      loading: true,
      data: [],
      id: 0,
      name: "",
      department_id: -1,
      errors: { load: "" },
      title: "Курсы",
    };
  },
  async mounted() {
    // это для фильтров:
    if (this.$route.query.department) {
      this.department_id = this.$route.query.department;
    } else {
      this.department_id = -1;
    }
    if (this.$route.query.name) {
      this.name = this.$route.query.name;
    } else {
      this.name = "";
    }
    // загрузка данных:
    this.loadRecords();
  },
  methods: {
    async loadRecords() {
      this.errors.load = "";
      try {
        this.loading = true;
        let p = { department: this.department_id, name: this.name };
        //let response = await axios.get('courses', { params: this.$route.query})
        let response = await axios.get("courses", { params: p });
        this.data = response.data;
        this.loading = false;
      } catch (e) {
        this.errors.load = "Ошибка при загрузке данных";
      }
    },
  },
};
</script>

